(() => {
  if (window.cubyfunV17Initialized) return;
  window.cubyfunV17Initialized = true;

  const closeMobileMenu = (header) => {
    header?.classList.remove('is-menu-open');
    header?.querySelector('[data-cubyfun-menu-toggle]')?.setAttribute('aria-expanded', 'false');
    const supportGroup = header?.querySelector('.cubyfun-mobile-nav__support-group');
    if (supportGroup) supportGroup.open = false;
  };

  const clampQuantity = (input, nextValue) => {
    const minimum = Number(input.min || 1);
    const maximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
    const step = Number(input.step || 1);
    const value = Math.min(maximum, Math.max(minimum, nextValue));
    input.value = String(Math.round(value / step) * step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  document.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-cubyfun-quantity]');
    if (quantityButton) {
      const control = quantityButton.closest('.qty');
      const input = control?.querySelector('input[name="quantity"]');
      if (!input) return;
      const direction = Number(quantityButton.dataset.cubyfunQuantity);
      clampQuantity(input, Number(input.value || input.min || 1) + direction);
      return;
    }

    const menuButton = event.target.closest('[data-cubyfun-menu-toggle]');
    if (menuButton) {
      const header = menuButton.closest('.cubyfun-header');
      const isOpen = header?.classList.toggle('is-menu-open') || false;
      menuButton.setAttribute('aria-expanded', String(isOpen));
      if (!isOpen) closeMobileMenu(header);
      return;
    }

    const menuLink = event.target.closest('.cubyfun-mobile-nav a');
    if (menuLink) {
      const header = menuLink.closest('.cubyfun-header');
      closeMobileMenu(header);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.cubyfun-header.is-menu-open').forEach(closeMobileMenu);
  });

  const motionBody = document.body;
  if (!motionBody?.classList.contains('cubyfun-v17-body')) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initializeMobileBuybar = () => {
    const buybar = document.querySelector('.mobile-buybar');
    const sourceButton = document.querySelector('.purchase-panel .add-button');
    if (!buybar || !sourceButton) return;

    const mobileViewport = window.matchMedia('(max-width: 760px)');
    let sourceButtonObserver;

    const setBuybarVisibility = (isVisible) => {
      buybar.classList.toggle('is-visible', isVisible);
      buybar.setAttribute('aria-hidden', String(!isVisible));
    };

    const observeSourceButton = () => {
      sourceButtonObserver?.disconnect();
      setBuybarVisibility(false);
      if (!mobileViewport.matches) return;

      sourceButtonObserver = new IntersectionObserver(
        ([entry]) => {
          const sourceButtonHasPassedAboveViewport =
            !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
          setBuybarVisibility(sourceButtonHasPassedAboveViewport);
        },
        {
          root: null,
          threshold: [0, 0.01],
        },
      );
      sourceButtonObserver.observe(sourceButton);
    };

    observeSourceButton();
    if (typeof mobileViewport.addEventListener === 'function') {
      mobileViewport.addEventListener('change', observeSourceButton);
    } else {
      mobileViewport.addListener(observeSourceButton);
    }
  };

  const motionSections = [
    ['.product-reveal', 'product-reveal', false],
    ['.benefits-section', 'benefits', false],
    ['.brand-manifesto', 'manifesto', false],
    ['.process', 'process', false],
    ['.quotes', 'quotes', false],
    ['.journey', 'journey', false],
    ['.feature-stack', 'feature-stack', false],
    ['.use-cases', 'use-cases', false],
    ['.faq-section', 'faq', false],
    ['.box-section', 'in-box', false],
  ];
  const motionItemGroups = [
    ['.benefits-section', '.benefit', 'benefit', false],
    ['.process', '.process-step', 'process-step', true],
    ['.journey', '.journey-item', 'journey-item', false],
    ['.feature-stack', '.feature-row', 'feature-row', true],
    ['.use-cases', '.case-card', 'case-card', true],
  ];

  let motionObserver;
  let motionItemObserver;
  let motionItemGroupObserver;
  const groupedMotionItems = new WeakMap();

  const revealMotionSection = (section) => {
    if (!section || section.classList.contains('is-in-view')) return;
    section.classList.add('is-in-view');
    motionObserver?.unobserve(section);
  };

  const revealMotionItem = (item) => {
    if (!item || item.classList.contains('is-item-in-view')) return;
    item.classList.add('is-item-in-view');
    motionItemObserver?.unobserve(item);
  };

  const revealMotionItemGroup = (container) => {
    const group = groupedMotionItems.get(container);
    if (!group) return;
    const compactViewport = window.matchMedia('(max-width: 760px)').matches;
    const interval = compactViewport
      ? 100
      : group.kind === 'feature-row'
        ? 180
        : group.kind === 'case-card'
          ? 150
          : 140;

    group.items.forEach((item, index) => {
      window.setTimeout(() => revealMotionItem(item), index * interval);
    });
    motionItemGroupObserver?.unobserve(container);
  };

  const prepareMotionSection = (section, kind, revealImmediately = false) => {
    if (!section || section.dataset.cubyfunMotionReady === 'true') return;
    section.dataset.cubyfunMotionReady = 'true';
    section.classList.add('cubyfun-motion', `cubyfun-motion--${kind}`);

    if (reduceMotion.matches) {
      revealMotionSection(section);
      return;
    }

    if (revealImmediately) {
      section.dataset.cubyfunMotionImmediate = 'true';
    } else {
      motionObserver?.observe(section);
    }
  };

  const prepareMotionItem = (item, kind, index, observeIndividually = true) => {
    if (!item || item.dataset.cubyfunMotionItemReady === 'true') return;
    item.dataset.cubyfunMotionItemReady = 'true';
    item.classList.add('cubyfun-motion-item', `cubyfun-motion-item--${kind}`);
    item.style.setProperty('--cubyfun-motion-index', String(index));

    if (reduceMotion.matches) {
      revealMotionItem(item);
    } else if (observeIndividually) {
      motionItemObserver?.observe(item);
    }
  };

  const prepareMotionTree = (root = document) => {
    motionSections.forEach(([selector, kind, revealImmediately]) => {
      if (root instanceof Element && root.matches(selector)) {
        prepareMotionSection(root, kind, revealImmediately);
      }
      root.querySelectorAll?.(selector).forEach((section) => {
        prepareMotionSection(section, kind, revealImmediately);
      });
    });

    motionItemGroups.forEach(([sectionSelector, itemSelector, kind, groupWhenAligned]) => {
      const sections = [];
      if (root instanceof Element && root.matches(sectionSelector)) {
        sections.push(root);
      }
      root.querySelectorAll?.(sectionSelector).forEach((section) => {
        sections.push(section);
      });
      sections.forEach((section) => {
        const items = [...section.querySelectorAll(itemSelector)];
        const layoutTops = items.map((item) => item.offsetTop);
        const shouldRevealAsGroup =
          groupWhenAligned &&
          items.length > 1 &&
          Math.max(...layoutTops) - Math.min(...layoutTops) <= 120;

        items.forEach((item, index) => {
          prepareMotionItem(item, kind, index, !shouldRevealAsGroup);
        });

        if (!shouldRevealAsGroup || reduceMotion.matches) return;
        const sharedParent = items.every((item) => item.parentElement === items[0].parentElement)
          ? items[0].parentElement
          : section;
        if (!sharedParent || sharedParent.dataset.cubyfunMotionGroupReady === 'true') return;
        sharedParent.dataset.cubyfunMotionGroupReady = 'true';
        groupedMotionItems.set(sharedParent, { items, kind });
        motionItemGroupObserver?.observe(sharedParent);
      });
    });
  };

  const initializeMotion = () => {
    if (reduceMotion.matches) {
      motionBody.classList.add('cubyfun-motion-reduced');
      prepareMotionTree();
      return;
    }

    motionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) revealMotionSection(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.14,
      },
    );
    motionItemObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) revealMotionItem(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -14% 0px',
        threshold: 0.2,
      },
    );
    motionItemGroupObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) revealMotionItemGroup(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.16,
      },
    );

    prepareMotionTree();

    requestAnimationFrame(() => {
      motionBody.classList.add('is-motion-ready');
      window.setTimeout(() => {
        document
          .querySelectorAll('[data-cubyfun-motion-immediate="true"]')
          .forEach(revealMotionSection);
      }, 220);
    });
  };

  initializeMobileBuybar();
  initializeMotion();

  document.addEventListener('shopify:section:load', (event) => {
    prepareMotionTree(event.target);
  });
})();
